module.exports = __webpack_public_path__ + "img/trashcan-large.3d63e02b.svg";